"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProvidersImportSelectHeader = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const loading_indicator_1 = require("client/components/ui/loading-indicator");
const store_1 = require("client/modules/providers/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
const button_1 = require("../../../../components/material/button");
const alert_1 = require("../../../../components/ui/alert");
require("./providers-import-select-header.less");
const core_1 = require("@material-ui/core");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const paper_1 = require("client/components/material/paper");
const router_1 = require("client/components/router");
let ProvidersImportSelectHeader = class ProvidersImportSelectHeader extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showConfirmationModal = false;
        this.loadingSaving = false;
        this.parsedRows = [];
        this.parsedRowsTruncated = [];
        this.rowSelected = false;
        this.selectedRowIndex = null;
        this.noHeaderRowSelectOnConfirm = false;
        this.getImportedRowsObject = () => {
            const headers = this.parsedRowsTruncated.slice(0, 1)[0]
                ? this.parsedRowsTruncated
                    .slice(0, 1)[0]
                    .map((header) => header.trim())
                : this.parsedRowsTruncated.slice(0, 1)[0];
            const rows = this.parsedRowsTruncated.slice(1);
            const importedData = rows.map(row => {
                const provider = {};
                row.forEach((value, index) => {
                    provider[headers[index]] = value;
                });
                return provider;
            });
            return importedData;
        };
        this.handleOnConfirmation = () => {
            if (!this.rowSelected) {
                this.noHeaderRowSelectOnConfirm = true;
            }
            else {
                store_1.providersStore.importColumnsHeader = this.parsedRows[this.selectedRowIndex || 0];
            }
            this.parsedRowsTruncated = this.parsedRows.slice(this.selectedRowIndex);
            store_1.providersStore.importedProviders = this.getImportedRowsObject();
            store_1.providersStore.selectedRowIndex = this.selectedRowIndex;
        };
        this.handleOnClickRow = (event, i) => {
            const rowClicked = document.getElementById(`select-header-table__row--${i}`);
            const allRows = document.getElementsByClassName("select-header-table__row");
            [...allRows].forEach(row => row.classList.remove("active-row"));
            rowClicked.classList.add("active-row");
            this.selectedRowIndex = i;
            this.rowSelected = true;
        };
        this.renderTableRow = (row, i) => (React.createElement(core_1.TableRow, { className: `select-header-table__row`, id: `select-header-table__row--${i}`, onClick: e => this.handleOnClickRow(e, i), key: i }, row.map((cell, i) => (React.createElement(core_1.TableCell, { className: "select-header-table__row--cell", key: i }, cell)))));
    }
    componentWillMount() {
        this.parsedRows =
            store_1.providersStore.parsedRows[0] && store_1.providersStore.parsedRows[0].length
                ? store_1.providersStore.parsedRows[0]
                : [];
        if (!this.parsedRows.length) {
            // console.log(
            //   'Redirecting to /import because no import or import has no rows',
            // );
            router_1.RouteManager.transitionTo(`/providers/import`);
        }
        // providersStore.importedProviders = this.getImportedRowsObject();
    }
    render() {
        return (React.createElement(react_1.Fragment, null,
            React.createElement("section", { className: "header-container--select" },
                React.createElement(kpi_header_1.KpiHeader, { center: false, noDivider: true },
                    React.createElement(kpi_title_1.KpiTitle, { label: "Header Selection", subLabel: "" })),
                React.createElement(paper_1.MaterialPaper, { className: "orders-submit-select__header-select" },
                    this.noHeaderRowSelectOnConfirm && (React.createElement("div", { className: "ui-alert--error" },
                        React.createElement(alert_1.UiAlert, { message: "Missing header row selection.", dismissable: true, onRequestDismiss: () => (this.noHeaderRowSelectOnConfirm = false) }))),
                    React.createElement("div", { className: "header-paper__message" },
                        React.createElement("h1", null, "Please select a header row"),
                        React.createElement("div", null,
                            React.createElement(button_1.MaterialButton, { to: "/providers" }, "Cancel"),
                            React.createElement(button_1.MaterialButton, { primary: true, onClick: this.handleOnConfirmation, to: this.rowSelected ? "/providers/import/map" : null, disabled: !this.rowSelected }, "confirm"))),
                    React.createElement("div", { className: "select-header-table", style: { overflow: "auto" } },
                        React.createElement(core_1.Table, null,
                            React.createElement(core_1.TableBody, null, this.parsedRows
                                .slice(0, 20)
                                .map((row, i) => this.renderTableRow(row, i))))))),
            this.loadingSaving && (React.createElement("div", { className: "header-container__loading-bg" },
                React.createElement(loading_indicator_1.UiLoadingIndicator, { className: "header-container__loading-indicator" }))),
            this.showConfirmationModal && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Confirm", cancelText: "Make changes", message: `Please confirm you have mapped the correct headers.`, onCancel: () => (this.showConfirmationModal = false), onConfirm: () => alert("confirmed"), title: "Confirm header mappings" }))));
    }
};
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "showConfirmationModal", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "loadingSaving", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "parsedRows", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "parsedRowsTruncated", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "rowSelected", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "selectedRowIndex", void 0);
__decorate([
    mobx_1.observable
], ProvidersImportSelectHeader.prototype, "noHeaderRowSelectOnConfirm", void 0);
ProvidersImportSelectHeader = __decorate([
    mobx_react_1.observer
], ProvidersImportSelectHeader);
exports.ProvidersImportSelectHeader = ProvidersImportSelectHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/providers/modules/providers-import-select-header/providers-import-select-header.tsx
// module id = 3849
// module chunks = 0